<template>
  <page-component id="websiterentals" :header="`${locationdescription}`">
    <commentcard-component v-if="locationcomment"
      id="websiterentals-commentcard"
      commentTitle="Information"      
      :commentImage="locationimage"
      :commentText="locationcomment"
      :commentCount="sites.length + ' ' + sitelabel + 's'">
    </commentcard-component>
    <group-component header="Search Criteria" :collapsible="true" :collapsed="true">
      <div id="websiterentals-filters">
        <div class="newline search-criteria newline-combobox" v-if="filters.class.options.length !== 0">
          <label id="websiterentals-class-filter_label" for="websiterentals-class-filter_label">{{rentalclasslabel}}</label>
          <div class="field-wrap combobox-field-wrap">
            <combobox-component 
              id="websiterentals-class-filter" 
              :disabled="processing"
              displayStyle="list"
              :multiple="true"
              emptyLabel="All Rental Classes"
              :items="filters.class.options" 
              v-model="filters.class.values"
              @change="onSearch(false)">
            </combobox-component>
          </div>
        </div>
        <div class="newline search-criteria newline-combobox" v-if="filters.type.options.length !== 0">
          <label id="websiterentals-type-filter_label" for="websiterentals-type-filter_label">{{typelabel}}</label>
          <div class="field-wrap combobox-field-wrap">           
            <combobox-component 
              id="websiterentals-type-filter" 
              :disabled="processing"
              displayStyle="list"
              :multiple="true"
              emptyLabel="All Types"
              :items="filters.type.options" 
              v-model="filters.type.values"
              @change="onSearch(false)">
            </combobox-component>
          </div> 
        </div>
        <div class="newline search-criteria newline-combobox" v-if="filters.category.options.length !== 0">
          <label id="websiterentals-category-filter_label" for="websiterentals-category-filter_label">{{categorylabel}}</label>
          <div class="field-wrap combobox-field-wrap">          
            <combobox-component 
              id="websiterentals-category-filter" 
              :disabled="processing"
              displayStyle="list"
              :multiple="true"
              emptyLabel="All Categories"
              :items="filters.category.options" 
              v-model="filters.category.values"
              @change="onSearch(false)">
            </combobox-component>
          </div> 
        </div>  
        <div class="newline search-criteria newline-combobox" v-if="filters.features.options.length !== 0">
          <label id="websiterentals-features-filter_label" for="websiterentals-features-filter_label">{{featureslabel}}</label>
          <div class="field-wrap combobox-field-wrap">  
            <combobox-component 
              id="websiterentals-features-filter" 
              :disabled="processing"
              displayStyle="list"
              :multiple="true"
              emptyLabel="All Features"
              :items="filters.features.options" 
              v-model="filters.features.values"
              @change="onSearch(false)">
            </combobox-component>
          </div> 
        </div>            
      </div>              
    </group-component>  
    <group-component header="">
      <div id="websiterentals-grid" class="expanded">
        <div id="websiterentals-controls">
          <div id="websiterentals-controls-top">
            <div id="websiterentals-controls-top-left">
              <datepicker-component 
                id="websiterentals-checkindate" 
                title="Check-In Date"
                label="Check-In Date"      
                :disabled="processing"
                :minDate="currentDate"
                @change="onCheckInDate($event)">
              </datepicker-component>     
              <datepicker-component 
                id="websiterentals-checkoutdate" 
                title="Check-Out Date"
                label="Check-Out Date"      
                :disabled="processing"
                :minDate="currentDate"
                :openRight="true"
                @change="onCheckOutDate($event)">
              </datepicker-component>
              <div id="websiterentals-wordsearch_wrap" class="fillin-wrap">
                <label id="websiterentals-wordsearch_label" for="websiterentals-wordsearch_input" class="fillin-label">Search {{sitelabel}} or {{looplabel}}</label>    
                <input
                  id="websiterentals-wordsearch_input"
                  class="fillin"
                  aria-labelledby="websiterentals-wordsearch_label"
                  type="text"
                  v-model="keywordSearch"
                  @input="onSearch(false)"
                  max-length="100">  
              </div>   
            </div>
            <div id="websiterentals-controls-top-right">       
              <button v-if="maxDaysToShow < 21"
                id="websiterentals-expand"
                type="button"
                class="button"
                title="Expand"
                aria-label="Expand"
                :disabled="processing"
                @click.prevent="onExpand()">
                <div class="icon">
                  <span>
                    <svgicon icon="glyph/16/expand" width="16" height="16"></svgicon>
                  </span>
                </div>  
                Expand
              </button>
              <button v-else
                id="websiterentals-condense"
                type="button"
                class="button"
                title="Condense"
                aria-label="Condense"
                :disabled="true"
                @click.prevent="onExpand()">
                <div class="icon">
                  <span>
                    <svgicon icon="glyph/16/condense" width="16" height="16"></svgicon>
                  </span>
                </div>  
                Condense
              </button>                
            </div>                                         
          </div> 
          <div id="websiterentals-controls-bottom">   
            <div id="websiterentals-controls-left">                         
              <button
                id="websiterentals-refresh"
                type="button"
                class="button"
                title="Refresh"
                aria-label="Refresh"
                :disabled="processing"
                @click.prevent="onRefresh()">
                <div class="icon">
                  <span>
                    <svgicon icon="glyph/16/refresh" width="16" height="16"></svgicon>
                  </span>
                </div>   
                Refresh
              </button> 
            </div>
            <div id="websiterentals-controls-right">                           
              <button
                id="websiterentals-prevweek"
                type="button"
                class="button primary"
                :title="'Previous ' + daysToMove + ' Days'"
                :aria-label="'Previous ' + daysToMove + ' Days'"                
                :disabled="processing"
                @click.prevent="onPrevNext(-1*daysToMove)">
                Prev {{ daysToMove }} Days
              </button>   
              <button
                id="websiterentals-nextavailable"
                type="button"
                class="button primary"
                title="Next Available"
                aria-label="Next Available"
                :disabled="true">
                Next Available
              </button>             
              <button
                id="websiterentals-nextweek"
                type="button"
                class="button primary"
                :title="'Next ' + daysToMove + ' Days'"
                :aria-label="'Next ' + daysToMove + ' Days'"
                :disabled="processing"
                @click.prevent="onPrevNext(daysToMove)">
                Next {{ daysToMove }} Days
              </button>   
            </div>                                  
          </div>                         
        </div>     
        <div id="websiterentals-table-scroll" ref="tableScroll"> 
          <div id="websiterentals-table-wrapper" ref="tableWrapper" @scroll="onScroll()">   
            <table id="websiterentals-table" class="rental-calendar-table">
              <thead ref="tableHead">
                <tr>
                  <th class="blank" colspan="2">                   
                  </th>
                  <th v-for="(column) in monthColumns" :key="column.desc" :colspan="column.span" class="month">
                    {{column.desc}}                 
                  </th>
                </tr>                             
                <tr>
                <th class="primary" :aria-sort="(sortOption === 'codeascending' ? 'ascending' : sortOption === 'codedescending' ? 'descending' : '')">
                  <button
                    id="websiterentals-sortcode"
                    type="button"
                    :title="sitelabel"
                    :aria-label="sitelabel"               
                    @click.prevent="onSort('code')">
                    {{sitelabel}}                 
                  </button>
                </th>                
                <th class="primary" :aria-sort="(sortOption === 'loopascending' ? 'ascending' : sortOption === 'loopdescending' ? 'descending' : '')">
                  <button
                    id="websiterentals-sortloop"
                    type="button"    
                    :title="looplabel"
                    :aria-label="looplabel"                                
                    @click.prevent="onSort('loop')">
                    {{looplabel}}                   
                  </button>
                </th>
                  <th v-for="(column) in displayedDates" :key="column.dateString" class="day">
                    {{column.descDay}} <br> {{column.descDate}}
                  </th>
                </tr>  
              </thead>  
              <tbody v-if="filteredSites.length != 0">
                <tr v-for="(site) in resultsSorted" :key="site.siteId"
                  ref="tableRow"
                  :id="'websiterentals-site' + site.siteId"
                  :disabled="processing">
                  <td class="primary info-cell" :aria-label="site.siteCode" :class="{selected:site.beginDate}">{{site.siteCode}}</td>                
                  <td class="info-cell" :aria-label="site.siteLoopDesc">{{site.siteLoopDesc}}</td>
                  <td v-if="site.dates.length !== displayedDates.length" aria-label="Loading Results" :colspan="daysToShow">Loading Results</td>
                  <div v-else class="day-container">
                    <td v-for="(day,column) in displayedDates" :key="site.dates[column].dateString"
                      :id="'websiterentals-site-' + site.siteId + '-day-' + column + 1">
                      <button
                        :id="'websiterentals-site-button-' + site.siteId + '-day-' + column + 1"
                        type="button"
                        :aria-label="site.dates[column].dateString + ' - Site ' + site.siteCode + ' is ' + (site.dates[column].status === 'A' ? 'Available' : (site.dates[column].status === 'U' ? 'Unavailable' : 'Reserved'))"
                        :class="{day:true, available: site.dates[column].status === 'A', unavailable: site.dates[column].status === 'U', reserved: site.dates[column].status === 'R',
                          selected: day && site.beginDate <= day.dateTime && site.endDate >= day.dateTime, 
                          begin: day && site.beginDate === day.dateTime, 
                          end: day && site.endDate === day.dateTime,}"
                        @click.prevent="onClickGrid(site, column)"
                        :title="(site.dates[column].status === 'R' ? 'Reserved' : site.dates[column].status === 'U' ? 'Unavailable' : site.dates[column].status === 'A' ? 'Available' : '')">
                        {{site.dates[column].status}}
                        <div v-if="day && site.endDate === day.dateTime" class="icon">
                          <span>
                            <svgicon icon="glyph/12/close" width="10" height="10"></svgicon>
                          </span>
                        </div>   
                      </button>                  
                    </td>
                  </div>
                </tr>  
              </tbody>             
            </table>
            <div id="websiterentals-empty-message" v-if="filteredSites.length == 0">There are no rental sites available based on the filters.</div>
          </div> 
          <button id="websiterentals-table-top-button" class="button primary" v-if="filteredSites.length > recordsToShow" @click.prevent="scrollTop()">
            <span>Top</span>
          </button> 
          <form ref="form" id="websiterentals-form" class="novalidate" :action="baseHref + 'addtocart.html'" method="post" @submit.prevent="submitForm()">
          <input type="hidden" name="Action" value="multiaddtocart" />
          <input type="hidden" name="SubAction" value="" />
          <input type="hidden" name="_csrf_token" :value="csrf" />
          <input type="hidden" name="Module" value="RN" />
          <input type="hidden" name="FromProgram" value="siterentals" />
          <input type="hidden" name="PreviousSearch" :value="'location=' + rentallocation" />
          <input type="hidden" name="SelectionList" :value="selectionList" />
          <multiselectlist-component 
            id="websiterentals-multiselectlist"
            :disabled="processing || selections.length === 0"
            v-model="selections"
            @change="clearSelections()"
            @submitForm="submitForm()">
          </multiselectlist-component>     
          </form>  
        </div>
      </div>   
      <div id="websiterentals-map">
        This is the map area (Coming soon).
      </div>             
    </group-component>  
  </page-component>
</template>

<script>
import SiteRentalsServices from "@/services/SiteRentalsServices"
import { mutations } from "@/store/types";

export default {
  name: "SiteRentals",
  props: {
    rentallocation: String,
    locationcomment: String,
    locationdescription: String,
    locationimage: String,    
    startdate: String,
    rentalclass: String,
    rentaltype: String,
    rentalcategory: String,
    rentalfeatures: String,
    rentalsiteloop: [String, Number],
    sitelabel: String,
    looplabel: String,
    rentalclasslabel: String,
    typelabel: String,
    categorylabel: String,
    featureslabel: String,
    sites: Array,
  },
  data() {
    return {
      csrf: App.settings.CSRFToken,
      baseHref: App.settings.BaseHref,
      processing: false,
      beginDate: null,
      checkOutDate: null, 
      checkInDate: null,        
      currentDate: null,  
      minDaysToShow: 7,
      maxDaysToShow: 21,
      daysToShow: 0,
      daysToMove: 7,
      recordsToShow: 10,
      keywordSearch: "",
      fetchEv: null,
      displayedDates:[{dateString: String, dateTime: Number, descDay: String, descDate: String}],
      monthColumns: [], 
      filteredSites: [],
      cachedSites: {},
      selections: [],    
      selectionList: "",  
      sortOption: "codeascending",  
      filters: {
        location:{
          options: [],
          values: []
        },
        class:{
          options: [],
          values: []
        },
        type:{
          options: [],
          values: []
        },
        category:{
          options: [],
          values: []
        },
        features:{
          options: [],
          values: []
        },           
      }      
    }
  },
  computed: { 
    resultsSorted() {
      let sortedSites = this.filteredSites;

      return sortedSites.sort((a, b) => { 
        if (this.sortOption === "loopascending") { 
          if (a.siteLoop == b.siteLoop) return 0;
          if (a.siteLoop > b.siteLoop) return 1;
          if (a.siteLoop < b.siteLoop) return -1; 
        } else if (this.sortOption === "loopdescending") { 
          if (a.siteLoop == b.siteLoop) return 0;
          if (a.siteLoop < b.siteLoop) return 1;
          if (a.siteLoop > b.siteLoop) return -1; 
        } else if (this.sortOption === "codedescending") { 
          if (a.siteCode == b.siteCode) return 0;
          if (a.siteCode < b.siteCode) return 1;
          if (a.siteCode > b.siteCode) return -1; 
        } else {
          if (a.siteCode == b.siteCode) return 0;
          if (a.siteCode > b.siteCode) return 1;
          if (a.siteCode < b.siteCode) return -1; 
        }
      });
    }
  },   
  created() { 
    let arrR;

    if (window.innerWidth > 990) {
      this.daysToShow = this.maxDaysToShow;
      this.daysToMove = 7;
    }
    else {
      this.daysToShow = this.minDaysToShow;
      this.daysToMove = 5;
    }

    window.addEventListener("resize", this.onResizeWindow);

    this.keywordSearch = this.rentalsiteloop.toString();
    this.beginDate = this.startdate;
    this.currentDate = new Date().toLocaleDateString("es-PA");

    if (new Date(this.beginDate) < new Date(this.currentDate)) {
      this.beginDate = this.currentDate;
    }

    this.sites.forEach(site => {
      this.$set(site, "beginTimeList", site.beginTimeList.split(","));
      this.$set(site, "endTimeList", site.endTimeList.split(","));

      if (site.siteClass != "") {
        arrR = this.filters.class.options.filter(function(ele){
          return (ele.value == site.siteClass);
        });

        if (!arrR.length) {
          this.filters.class.options.push({label: site.siteClassDesc, value: site.siteClass});
        } 
      }

      if (site.siteType != "") {
        arrR = this.filters.type.options.filter(function(ele){
          return (ele.value == site.siteType);
        });

        if (!arrR.length) {
          this.filters.type.options.push({label: site.siteTypeDesc, value: site.siteType});
        } 
      }

      if (site.siteCategory != "") {
        arrR = this.filters.category.options.filter(function(ele){
          return (ele.value == site.siteCategory);
        });

        if (!arrR.length) {
          this.filters.category.options.push({label: site.siteCategoryDesc, value: site.siteCategory});
        } 
      }

      if (site.siteFeatures != "") {
        let featureArray = site.siteFeatures.split(",");
        let featureDescArray = site.siteFeaturesDesc.split(",");

        featureArray.forEach((feature, index) => {
          arrR = this.filters.features.options.filter(function(ele){
            return (ele.value == feature);
          });

          if (!arrR.length) {
            this.filters.features.options.push({label: featureDescArray[index], value: feature});
          } 
        });
      }
    }) 

    this.setSelectedFilters();
    this.onSearch(true);       
  },

  mounted(){
    this.setGridHeight();
  },
  watch: {
    selections() {
      if (this.selections.length === 0) {
        this.selectionList = "";
      } else {
        let tempList = [];

        this.selections.forEach((selection) => {
          tempList.push(selection.siteId + "|" + selection.beginDate + "|" + selection.endDate + "|" + selection.beginTime + "|" + selection.endTime);
        });  

        this.selectionList = tempList.join(","); 
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.onResizeWindow);
  },   

  methods: {
    setGridHeight(){

      if(!this.$refs.tableWrapper) return;

      this.$refs.tableWrapper.scrollTo({top: 0});

      let tableHeight = 250;
      let tablePadding = 0;
      let rowHeight = 49; 
      let noRecords = this.recordsToShow;

      if(this.filteredSites.length === 0){ 
        this.$refs.tableScroll.style.height = tableHeight + "px";
        this.$refs.tableWrapper.style["padding-bottom"] = tablePadding + "px";
        this.$refs.tableScroll.classList.add("bottom");
        return;
      }

      if(this.$refs.tableRow && this.$refs.tableRow[0]){
        rowHeight = this.$refs.tableRow[0].clientHeight;
      }

      if(this.filteredSites.length <= this.recordsToShow){ 
        noRecords = this.filteredSites.length;
        tableHeight = this.$refs.tableScroll.style.height = this.$refs.tableHead.clientHeight + 1 + noRecords * (rowHeight + 1) + "px";
        this.$refs.tableScroll.style.height = tableHeight + 1 + noRecords * (rowHeight + 1) + "px";
        this.$refs.tableScroll.classList.add("bottom");
        this.$refs.tableWrapper.style["padding-bottom"] = tablePadding + "px";
        return;
      }
     

      // tableheight = headerHeight + border + recordsShown*(rowHeight + recordBorder) + partOfNextRecord
      tableHeight = this.$refs.tableHead.clientHeight + 1 + noRecords * (rowHeight + 1) + rowHeight/2; 
      this.$refs.tableScroll.style.height = tableHeight + "px";
      if(this.$refs.tableWrapper.scrollTop + this.$refs.tableWrapper.clientHeight === this.$refs.tableWrapper.scrollHeight){
        this.$refs.tableScroll.classList.remove("bottom");
      }
      this.$refs.tableWrapper.style["padding-bottom"] = "55px";
    },

    scrollTop(){
      this.$refs.tableWrapper.scrollTo({top: 0, behavior: 'smooth'});
    },

    onScroll(){
      if(this.$refs.tableWrapper.scrollTop + this.$refs.tableWrapper.clientHeight === this.$refs.tableWrapper.scrollHeight){
        this.$refs.tableScroll.classList.add("bottom");
      }
      else{
        this.$refs.tableScroll.classList.remove("bottom");
      }
    },

    onResizeWindow() {
      if(window.innerWidth>990 && this.daysToShow!==this.maxDaysToShow) {
        this.daysToShow = this.maxDaysToShow;
        this.daysToMove = 7;
        this.fetchSiteData(true);
      }
      else if(window.innerWidth<=990 && this.daysToShow!==this.minDaysToShow) {
        this.daysToShow = this.minDaysToShow;
        this.daysToMove = 5;
        this.fetchSiteData(true);
      }
    },
    setSelectedFilters() {
      let selectedArray;

      if (this.rentalclass) {
        selectedArray = this.rentalclass.split(",");
        selectedArray.forEach(opt => {
          this.filters.class.options.forEach(element => {
            if (element.value === opt) {
              this.filters.class.values.push(opt);
              return;
            }
          });   
        });
      }
  
      if (this.rentaltype) { 
        selectedArray = this.rentaltype.split(",");
        selectedArray.forEach(opt => {      
          this.filters.type.options.forEach(element => {
            if (element.value === opt) {
              this.filters.type.values.push(opt);
              return;
            }
          });  
        });
      }

      if (this.rentalcategory) { 
        selectedArray = this.rentalcategory.split(",");
        selectedArray.forEach(opt => {    
          this.filters.category.options.forEach(element => {
            if (element.value === opt) {
              this.filters.category.values.push(opt);
              return;
            }
          }); 
        });
      }

      if (this.rentalfeatures) {  
        selectedArray = this.rentalfeatures.split(",");
        selectedArray.forEach(opt => {    
          this.filters.features.options.forEach(element => {
            if (element.value === opt) {
              this.filters.features.values.push(opt);
              return;
            }
          });  
        });
      } 

      return;
    },    
    onSearch(dateChange) {
      this.filteredSites = this.sites.filter((site) => {
        let skipSite = false;

        if (this.filters.class.values.length && !this.filters.class.values.find((value) => value === site.siteClass)) {
          return false;
        } 

        if (this.filters.type.values.length && !this.filters.type.values.find((value) => value === site.siteType)) {
          return false;
        } 

        if (this.filters.category.values.length && !this.filters.category.values.find((value) => value === site.siteCategory)) {
          return false;
        } 

        if (this.filters.features.values.length) {
          this.filters.features.values.forEach((feature) => {
            const featureArr = site.siteFeatures.split(",");

            if (!featureArr.find((value) => value === feature)) {
              skipSite = true;
            } 
          });   
        }         

        if (skipSite) {
          return false;
        }

        if (this.keywordSearch != "" && !site.siteCode.toLowerCase().includes(this.keywordSearch.toLowerCase()) && 
          !site.siteLoopDesc.toLowerCase().includes(this.keywordSearch.toLowerCase())) {
          return false;
        }        

        return true;
      }).map(s => {
        return Object.assign({}, s, {
          dates: []
        })
      })  

      this.setSiteSelections(); 
      this.fetchSiteData(dateChange); 
      this.setGridHeight();
    },
    fetchSiteData(dateChange) {
      if (dateChange) {
        this.updateDisplayedDates();

        this.filteredSites.forEach((site) => {
          site.dates = [];
        });  
      }

      if (this.fetchEv) {
        clearTimeout(this.fetchEv);
      }

      this.fetchEv = setTimeout(() => {
        this.fetchData();
      },500)
    },  
    fetchData() {
      const siteList = [];
      const checkDateTime = new Date().getTime();
      const displayedDates = this.displayedDates.map(d => d.dateString);
      const tempFilteredSites = [...this.filteredSites];

      this.filteredSites.forEach((s) => {
        if (!this.cachedSites[s.siteId]) {
          this.cachedSites[s.siteId] = [];
        }

        this.cachedSites[s.siteId] = this.cachedSites[s.siteId].filter(c => {
          return c.cached >= checkDateTime;
        });

        const cachedGoodDates = this.cachedSites[s.siteId].map(d => d.date.toLocaleDateString("es-PA"));
        const dateList = displayedDates.filter(d => !cachedGoodDates.includes(d));

        if(dateList.length) {
          siteList.push(s.siteId + "|" + dateList.join("&"));
        }
      });   

      if(!siteList.length) {
        tempFilteredSites.forEach((site) => {
          site.dates = this.cachedSites[site.siteId].filter((d) => {
            return displayedDates.includes(d.date.toLocaleDateString("es-PA"));
          });
        }); 
      } else {
        this.processing = true;

        SiteRentalsServices.getSiteData( siteList.join(",") )
          .then((response) => {
            const cacheDateTime = new Date().getTime() + 300000;

            tempFilteredSites.forEach((site) => {
              const rec = response.sitedata.find(s => s.siteId === site.siteId);

              if (rec) {
                this.cachedSites[rec.siteId] = [...this.cachedSites[rec.siteId], ...rec.dates.map(d => {
                  return Object.assign({}, d, {
                    cached: cacheDateTime,
                    dateString: d.date,
                    date: new Date(d.date)
                  })
                })];
              }

              site.dates = this.cachedSites[site.siteId].filter((d) => {                
                return displayedDates.includes(d.dateString);
              });

            })
            this.processing = false;
          })
          .catch(() => {
            this.processing = false;
          });
      }

      this.filteredSites = tempFilteredSites;
    },    
    onClickGrid(site, column) {
      let removed = false;
      //if(site.dates[column].status !== "A") return;

      if (!site.beginDate) {
        this.$set(site, "beginDate", this.displayedDates[column].dateTime);
        this.$set(site, "endDate", this.displayedDates[column + 1].dateTime);
      } else if (site.endDate === this.displayedDates[column].dateTime) {
        this.$set(site, "beginDate", undefined);
        this.$set(site, "endDate", undefined);

        removed = true;
      } else if (site.endDate < this.displayedDates[column].dateTime) {
        this.$set(site, "endDate", this.displayedDates[column].dateTime);
      } else if (site.beginDate > this.displayedDates[column].dateTime) {
        this.$set(site, "beginDate", this.displayedDates[column].dateTime);
      }

      this.selections = this.selections.filter(function(s){
        return (s.siteId != site.siteId);
      });

      if (!removed) {
        const tempBeginDate = new Date(site.beginDate);
        const tempEndDate = new Date(site.endDate);
        const beginDateFormatted = tempBeginDate.toLocaleDateString("es-PA");
        const endDateFormatted = tempEndDate.toLocaleDateString("es-PA");
        const tempBeginTime = site.beginTimeList[tempBeginDate.getDay()];
        const tempEndTime = site.endTimeList[tempEndDate.getDay()];

        this.selections.push({siteId: site.siteId, beginDate: beginDateFormatted, endDate: endDateFormatted, 
          beginDateTime: tempBeginDate.getTime(), endDateTime: tempEndDate.getTime(), beginTime: tempBeginTime, endTime: tempEndTime,
          siteCode: site.siteCode, siteDescription: site.siteDescription,
          subDescription: beginDateFormatted + " @ " + tempBeginTime + " - " + endDateFormatted + " @ " + tempEndTime});
      }   
    },   
    updateDisplayedDates() {
      const daysOfWeek = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      const monthsOfYear = ['Jan','Feb','Mar','Apr','May','June','July','Aug','Sept','Oct','Nov','Dec'];
      const begDate = new Date(this.beginDate);
      this.monthColumns = [];
      
      this.displayedDates = [{dateString: begDate.toLocaleDateString("es-PA"), dateTime: begDate.getTime(), descDay: daysOfWeek[begDate.getDay()], descDate: begDate.getDate()}];
      this.monthColumns.push({desc: monthsOfYear[begDate.getMonth()], span: 1});
     
      for (let day = 1; day <= this.daysToShow - 1; day++) {
        begDate.setDate(begDate.getDate() + 1);
        this.displayedDates.push({dateString: begDate.toLocaleDateString("es-PA"), dateTime: begDate.getTime(), descDay: daysOfWeek[begDate.getDay()], descDate: begDate.getDate()});
        const monthExists = this.monthColumns.find(m => m.desc === monthsOfYear[begDate.getMonth()]);

        if (monthExists) {
          monthExists.span = monthExists.span + 1;     
        } else {
          this.monthColumns.push({desc: monthsOfYear[begDate.getMonth()], span: 1});
        }
      }
    },      
    onPrevNext(days) {
      if (!days) {
        return;
      }   

      const tempCurrent = new Date(this.currentDate);
      let newBeginDate = new Date(this.beginDate);
      newBeginDate.setDate(newBeginDate.getDate() + days);  
      
      if (newBeginDate < tempCurrent) {    
        newBeginDate = this.currentDate;
      } else {
        newBeginDate = newBeginDate.toLocaleDateString("es-PA");
      }

      if (this.beginDate !== newBeginDate) {
        this.beginDate = newBeginDate;
        this.fetchSiteData(true); 
      }

      return days;
    },     
    onCheckInDate(event) {
      if (!event) {
        return;
      }     
      
      const begDate = new Date(event);

      if (begDate instanceof Date) {
        this.beginDate = begDate.toLocaleDateString("es-PA");
        this.checkInDate = this.beginDate;
        this.fetchSiteData(true); 
      }

      return;
    },     
    onCheckOutDate(event) {
      if (!event) {
        return;
      }     
      
      const endDate = new Date(event);

      if (endDate instanceof Date) {
        this.checkOutDate = endDate.toLocaleDateString("es-PA");
      }

      return;
    },     
    onRefresh() {
      this.cachedSites = {};
      this.fetchSiteData(true); 

      return;
    }, 
    onExpand() {
      // Commented out for beta release
      /*if (this.maxDaysToShow === 10) {
        this.maxDaysToShow = 21;
        this.daysToShow = this.maxDaysToShow;
        document.getElementById("websiterentals-grid").classList.add("expanded");
        document.getElementById("websiterentals-map").style.display = "none";
      } else {
        this.maxDaysToShow = 10;
        this.daysToShow = this.maxDaysToShow;
        document.getElementById("websiterentals-grid").classList.remove("expanded");  
        document.getElementById("websiterentals-map").style.display = "block";      
      }

      this.fetchSiteData(true);
      */
      return;
    },
    onSort(column) {
      if (column === "code") {
        if (this.sortOption === "codedescending" || this.sortOption.startsWith('loop')) {
          this.sortOption = "codeascending";
        } else {
          this.sortOption = "codedescending";
        }
      } else if (column === "loop") {
        if (this.sortOption === "loopdescending" || this.sortOption.startsWith('code')) {
          this.sortOption = "loopascending";
        } else {
          this.sortOption = "loopdescending";
        }
      }

      return;
    },       
    setSiteSelections() {
       this.selections.forEach((selection) => {
        const site = this.filteredSites.find((s) => s.siteId === selection.siteId);
        if (site) {
          this.$set(site, "beginDate", selection.beginDateTime);
          this.$set(site, "endDate", selection.endDateTime);
        }
      });

      return;
    },           
    clearSelections() {
      this.selections = [];

      this.filteredSites.forEach((site) => {
        this.$set(site, "beginDate", undefined);
        this.$set(site, "endDate", undefined);
      });  

      return;
    },      
    submitForm() {
      if (this.selectionList === "") {
        this.$store.commit(mutations.ADD_MESSAGE, {
          type: "error", 
          text: "There are no selections to add to the cart."
        });
  
        return;
      }

      this.processing = true;
      this.$refs.form.submit();       
    }    
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/abstract/variables";
@import "../../assets/css/abstract/mixins";
@import "../../assets/css/components/table";

#websiterentals {

  #websiterentals-filters {
    display: flex;
  } 

  .search-criteria {
    display: block;
    width: 24%;
    margin-right: 1%;
    float: left;
      
    label {
      width: 100%;
    }   
  }

  #websiterentals-grid {
    display: flex;
    flex-flow: column;
    width: 55%;
    float: left;

    #websiterentals-controls {
      width: 100%;
      float: left;
      margin-bottom: 10px;

      #websiterentals-controls-top {
        width: 100%;
        padding: 12px;
        margin-bottom: 12px;
        float: left;
        background: @gray-color;
        border-radius: 4px;
        border: solid 1px rgba(192, 192, 192, 0.5);

        #websiterentals-controls-top-left {
          float: left;
          
          .datepicker-wrap {
            float: left;
            width: 130px;
            margin-right: 12px;
          }

          .fillin-wrap {
            float: left;
            margin-right: 12px;
            width: 150px;

            .fillin-label {
              width: 100%;
            }
          }
        }

        #websiterentals-controls-top-right {
          float: right;

          #websiterentals-expand, #websiterentals-condense {
            text-align-last: center;
            margin-left: 0;
            margin-right: 0;
            margin-top: 27px;
            padding: 0 12px 0 30px;
            float: right;
            position: relative;
          }
        }
      }

      #websiterentals-controls-bottom {
        float: left;
        width: 100%;

        #websiterentals-controls-left {
          float: left;

          button {
            margin-left: 0;
            margin-right: 12px;
            padding: 0 10px 0 30px;
            position: relative;            
          }            
        }

        #websiterentals-controls-right {
          float: right;

          button {
            margin-left: 12px;
            margin-right: 0;
            padding: 0 12px;
          }  
        }  
      }

      .primary {
        background-color: #015c8e;
        color: #FFF;

        &:hover, &:focus {
          background-color: #005486;
        }

      }
      
      .icon {
        position: absolute;
        top: 25%;
        left: 5px;
        width: 16px;
        height: 16px;

        .svg-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -8px;
          margin-left: -5px;

          & * {
            fill: #FFF;
          }
        }
      }
    }  

  } 

  #websiterentals-grid.expanded {
    width: 100%;
  }

  #websiterentals-map {
    display: none;
    width: 44%;
    margin-left: 1%;
    float: left;
  }   

}

#websiterentals-table-scroll{
  width: 100%;
  position: relative;

}

#websiterentals-table-scroll::after { 
  content: '';
  position: absolute;
  z-index: 3;
  left: 0px;
  right: 0px;
  height: 15%;
  bottom: 0px;
  background: linear-gradient(180deg, transparent 0%, rgb(255, 255, 255) 100%);
  pointer-events: none;
}

#websiterentals-table-scroll.bottom::after { 
  display: none;
}

#websiterentals-table-top-button{
    position: absolute;
    bottom: 18px;
    right: 15px;
    z-index: 4;
    background-color: #005486dd;
    color: white;
    border-radius: 50%;
    height: 45px;
    width: 45px;

    span{
      margin-left: -6.5px;
    }

    &:hover, &:focus {
      background-color: #005486;
    }    
}

#websiterentals-table-wrapper{
  position: relative;
  width: 100%; 
  height: 100%; 
  padding-bottom: 55px; 
  overflow-y: scroll; 
  overflow-x: hidden;
  scrollbar-width: none; 

  #websiterentals-empty-message{
    position: absolute;
    top: 50%;
    width: 100%;
    text-align: center;
  }
}

#websiterentals-table-wrapper::-webkit-scrollbar {
  display: none;
}

.rental-calendar-table {
  width: 100%;
  font-size: 100%;
  border-collapse: separate;

  thead{
    position: sticky;
    top: 0;
    z-index: 3;
  }
    
  tr {
    overflow: visible;
  }

  tr:hover {
    .primary.info-cell {
      background: #015c8e;
      color: #FFF;
    }
  }

  th {
    padding: 6px 12px;
    overflow: hidden;
    color: #272c33;
    font-weight: 600;
    background: #FFF;
    font-size: @font-size-14px;
    position: relative;
    width: 49px;
    height: 40px;
    padding: 0;
    text-align: center;
    line-height: 1.1;
    
  }

  th.primary {
    background: #015c8e;
    color: #FFF;
    width: 88px;

    &:first-child {
      border-right: solid 1px #FFF;
    }

    button {
      background: transparent;
      text-align: center;
      position: relative;
      width: 100%;
      height: 100%;
      color: #FFF;
      cursor: pointer;

      &:hover, &:focus {
        background: #005486;
      } 
    }    
  }

  th.day {
    background: #46545f;
    color: #FFF;
    font-size: 13px;
    border-left: solid 1px rgba(192, 192, 192, 0.5);
  }  

  th.month {
    border-top: solid 1px rgba(192, 192, 192, 0.5);
    border-left: solid 1px rgba(192, 192, 192, 0.5);

    &:last-child {
      border-right: solid 1px rgba(192, 192, 192, 0.5);
    }      
  }    

  th.blank {
    border: none;
  }

  td {
    background: #FFF;
    color: #272c33;
    padding: 6px 12px;
    font-size: @font-size-14px;
    height: 49px;
    padding: 0;
    text-align: center;
    border-right: solid 1px rgba(192, 192, 192, 0.5);
    border-bottom: solid 1px rgba(192, 192, 192, 0.5);
    vertical-align: middle;

    a,
    a:link,
    a:active,
    a:hover {
      font-size: @font-size-14px;
    }     
    
    a.fill-cell {
      width: 100%;
    }
    
    &.no-wrap {
      white-space: nowrap;
    }
      
    &.button-cell {
      &--more {
        overflow: visible;
      }
    }
    
    button {
      background: transparent;
      text-align: center;
      position: relative;
      width: 100%;
      height: 100%;
      
      .icon {
        position: absolute;
        top: 2px;
        right: -5px;
        width: 16px;
        height: 16px;
        background: #E60013;
        border-radius: 100%;
        z-index: 2;
    
        .svg-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -5px;
          margin-left: -5px;
    
          & * {
            fill: #FFF;
          }
        }
      }

      &:focus {
        outline: 2px solid #000;
        z-index: 1;
      }

    }    
  }

  .day-container {
    display: contents;
  }

  .day {
    overflow: visible;
  }

  .primary {
    color: #015c8e;
  }
  
  .available {
    background-color: #e6f2f8;
    color: #015c8e;
    font-weight: 700;
  }

  .unavailable, .reserved {
    color: #272c33;
  }

  .day.available:hover, .day.available:focus {
    background-color: #CFDADF;
  }

  .day.selected {
    background-color: #015c8e;
    color: #015c8e;
    border-color:  #015c8e;
    box-shadow: 1px 0 0 #015c8e;  
  }

  .day.selected:hover, .day.selected:focus {
    background-color: #015380;
    color: #015380;
  }

  .day.selected.begin {
    box-shadow: 1px 0 0 #015c8e, inset 4px 0 0 #000;    
  }
  .day.selected.end {
    box-shadow: inset -4px 0 0 #000;    
    border-right: none;
  }

  .primary.info-cell {
    border-left: solid 1px rgba(192, 192, 192, 0.5); 
  }

  .primary.info-cell.selected {
    box-shadow: inset 4px 0 0 #015c8e;    
    border-left: none;
  }

  .cell-inner {
    display: block;
    font-weight: 400;
  }
}

@media @tablet-down { 

  #websiterentals-filters {
    display: block !important;
  } 

  .search-criteria {
    width: 100% !important;
    margin-right: 0 !important;
  }

  #websiterentals-grid {
    width: 100% !important;

    #websiterentals-controls {

      #websiterentals-controls-top {
        width: 100% !important;
        display: block !important;

        input {
          width: 100% !important;
        }  

        .datepicker-wrap {
          width: 48% !important;
          margin: 0 !important;

          &:first-child {
            margin-right: 4% !important;
          }
        }

        .fillin-wrap {
          width: 100% !important;
          margin: 8px 0 0 0 !important;
        }      

        #websiterentals-controls-top-left {
          width: 100%;
        }

        #websiterentals-controls-top-right {
          width: 100%;

          #websiterentals-expand, #websiterentals-condense {
            display: none;
          }
        }
      }  

      #websiterentals-controls-left {
        width: 100% !important;
        margin-bottom: 4px !important;

        button {
          margin-top: 0 !important;
          margin-right: 0 !important;
        } 
      } 

      #websiterentals-controls-right {
        width: 100% !important;
        margin-bottom: 2px !important;

        button {
          margin: 0 0 0 2% !important;
          width: 32% !important;
          padding: 0 2px !important;
          line-height: 1;

          &:first-child {
            margin-left: 0 !important;
          }
        } 
      }    
    }

  } 

  #websiterentals-map {
    display: none;
  }   

}

</style>